import format from 'date-fns/format';

import CurrentSupplier from 'types/CurrentSupplier';
import InfoIcon from 'assets/icons/info.svg';
import NoSSR from '@misc/NoSSR';
import Typography from '@components/atoms/Typography';
import Tooltip from '@templates/Tooltip';
import RelativeAvailabilityTimespan from '@templates/RelativeAvailabilityTimespan';
import { FormattedMessage } from 'utils/intl';

import classes from './ComplexDeliveryLabel.module.scss';
import messages from './ComplexDeliveryLabel.messages';

export type Props = {
  className?: string;
  isEol: boolean;
  isPrerelease: boolean;
  isAvailable: boolean;
  daysToDelivery: number;
  currentSupplier?: CurrentSupplier;
};

const ComplexDeliveryLabel = ({
  className,
  isEol,
  isPrerelease,
  isAvailable,
  daysToDelivery,
  currentSupplier,
}: Props) => (
  <Typography className={className} variant="caption1" lineHeight="18px" renderAs="div">
    {!isPrerelease && !currentSupplier?.availabilityTypeId && isAvailable && !isEol && (
      <div className={classes.availabilityNow}>
        <NoSSR>
          {daysToDelivery <= 2 ? (
            <FormattedMessage {...messages.availableNow} />
          ) : (
            <FormattedMessage tagName="div" {...messages.closestShipping} values={{ days: daysToDelivery }} />
          )}
        </NoSSR>
      </div>
    )}
    {isPrerelease && (
      <span className={classes.prereleaseProduct}>
        <FormattedMessage {...messages.prereleaseProduct} />
      </span>
    )}
    {!isPrerelease && !currentSupplier?.availabilityTypeId && (!isAvailable || isEol) && (
      <span className={classes.productNotAvailable}>
        <FormattedMessage {...(isEol ? messages.eolProduct : messages.askForAvailability)} />
      </span>
    )}
    {!isPrerelease && currentSupplier?.availabilityTypeId === 'ABSOLUTE' && currentSupplier.availabilityDate && (
      <FormattedMessage
        {...messages.availableFrom}
        values={{
          date: format(new Date(currentSupplier.availabilityDate), 'dd.MM.yyyy'),
        }}
      />
    )}
    {!isPrerelease && currentSupplier?.availabilityTypeId === 'RELATIVE' && (
      <>
        <RelativeAvailabilityTimespan timespan={currentSupplier.availabilityTimespan} />
        {!!currentSupplier.availabilityTimespan.description && (
          <Tooltip title={currentSupplier.availabilityTimespan.description} classes={{ root: classes.tooltip }}>
            <InfoIcon className={classes.tooltipIcon} />
          </Tooltip>
        )}
      </>
    )}
  </Typography>
);

export default ComplexDeliveryLabel;
